import React, { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { LogsIcon, LogsIconActive } from "assets/images";
import {
    CustomAntCheckbox,
    CustomLogOut,
    CustomTabsIcon,
    CustomTabsSettingsIcon,
    Icon,
    IconWrapper,
    LogsIconWrapper,
    RightIcons,
    RightWrapper,
} from "./sideMenuStyles";
import { logOut } from "store/reducers/AuthSlice";
import TabsSideDropdown from "components/SideDrop/TabsSideDropdown/TabsSideDropdown";
import TabsLayoutDropdown from "components/SideDrop/TabsLayoutDropdown/TabsLayoutDropdown";
import {
    SettingItem,
    SettingsContainer,
    SettingsItems,
    SettingsMenu,
} from "../BasedTable/basedTableStyles";
import CombineLogsModal from "../CombineLogsModal/CombineLogsModal";
import { useAppSelector } from "../../hooks/redux";
import {
    changeLogsStatus,
    getLogsStatus,
} from "../../store/reducers/LogsSlice";
import { resetTabsState } from "../../store/reducers/TabsSlice";
import { resetQuotesPageState } from "../../store/reducers/QuotesPageReducer";
import CombineLogsResultModal from "components/CombineLogsResultModal/CombineLogsResultModal";
import { resetQuotesState } from "../../store/reducers/quotes";
import { changeTickerBlockStatus, resetState } from "../../store/reducers/SettingsSlice";
import { pathname } from 'store/reducers/ActionCreators';

const server_pathname = pathname.slice();

interface IProps {
    pathname: string;
}

const token = Cookies.get("access");

const _path = pathname.replace('https://', '').replace('http://', '');

const ws_path = `ws${!pathname.includes('https://') ? '' : 's'}://${_path}wss/logs/?token=${token}`;

const LogsSocket = new WebSocket(
    ws_path
    //`wss://pot-website.sixhands.co/wss/logs/?token=${token}`
);

const Settings = () => {
    const dispatch = useDispatch();
    const { logsStatus } = useAppSelector((state) => state.logs);
    const { activeTicker: ticker, activeGroup: group } = useAppSelector(
        (state) => state.settings
    );
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [combineLogsModalOpened, setCombineLogsModalOpened] = useState(false);
    const [combineLogsResultModalOpened, setCombineLogsResultModalOpened] =
        useState(false);

    const [showCheckbox, setShowCheckbox] = useState(true);
    const [status, setStatus] = useState<boolean | string>(false);
    const [combineLogsResultInfoString, setCombineLogsResultInfoString] =
        useState<string>("{}");

    useEffect(() => {
        LogsSocket.onopen = function (e) {
            //console.log("[open] Соединение logs установлено");
            LogsSocket.send("Hello");
        };

        LogsSocket.onmessage = function (message) {
            setCombineLogsResultInfoString(message.data);
            setCombineLogsResultModalOpened(true);
        };

        LogsSocket.onclose = function (event) {
            if (event.wasClean) {
                console.log(
                    `[close] Соединение закрыто чисто, код=${event.code} причина=${event.reason}`
                );
            } else {
                // например, сервер убил процесс или сеть недоступна
                // обычно в этом случае event.code 1006
                console.log("[close] Соединение прервано");
            }
        };
        LogsSocket.onerror = function (error: ErrorEvent) {
            console.log(`[error] ${error.message}`);
        };
    }, []);

    // const { sendMessage, lastMessage, readyState } = useWebSocket(
    //     "ws://pot-website.sixhands.co/api/wss/logs"
    // );

    // useEffect(() => {
    //     console.log(readyState);
    //     if (lastMessage) {
    //         console.log(lastMessage.data);
    //     }
    // }, [lastMessage, readyState]);

    // useEffect(() => {
    //     if (readyState) {
    //         sendMessage("Roma");
    //     }
    // }, [readyState]);

    const handleChangeStatus = () => {
        dispatch(changeLogsStatus());
        dispatch(getLogsStatus(ticker.name));
    };

    const handleCombineLogs = () => {
        setIsSettingsOpen(false);
        setCombineLogsModalOpened(true);
    };

    useEffect(() => {
        if (group.name === "default") {
            setShowCheckbox(true);
            setStatus(logsStatus);
        } else {
            setShowCheckbox(false);
        }
    }, [group, logsStatus]);

    return (
        <SettingsContainer
            active={isSettingsOpen}
            // use below props if group validation is required
            disabled={false} // groupTickers.length === 0
            title={false ? "Группа тикеров не выбрана" : ""} //groupTickers.length === 0
        >
            <LogsIconWrapper
                onClick={() => {
                    if (true) {
                        /* ^-- groupTickers.length !== 0 <-- use  this condition if group validation is required*/
                        setIsSettingsOpen((state) => !state);
                    }
                }}
            >
                {isSettingsOpen /* {groupTickers.length === 0} <-- use  this condition if group validation is required */ ? (
                    <LogsIconActive/>
                ) : (
                    <LogsIcon/>
                )}
            </LogsIconWrapper>
            <SettingsMenu active={isSettingsOpen}>
                <SettingsItems>
                    {showCheckbox && (
                        <SettingItem>
                            <CustomAntCheckbox
                                onChange={handleChangeStatus}
                                checked={status as boolean}
                            />
                            <span>Сохранить логи</span>
                        </SettingItem>
                    )}
                    <SettingItem onClick={handleCombineLogs}>
                        <span>Свести логи</span>
                    </SettingItem>
                </SettingsItems>
            </SettingsMenu>

            <CombineLogsModal
                isOpen={combineLogsModalOpened}
                onRequestClose={() => setCombineLogsModalOpened(false)}
            />

            <CombineLogsResultModal
                info={combineLogsResultInfoString}
                isOpen={combineLogsResultModalOpened}
                onRequestClose={() => setCombineLogsResultModalOpened(false)}
            />
        </SettingsContainer>
    );
};

const RightSideMenu = ({ pathname }: IProps) => {
    const dispatch = useDispatch();
    const [isTabsSelectOpened, setIsTabsSelectOpened] = useState(false);
    const [isTabsLayoutOpened, setIsTabsLayoutOpened] = useState(false);
    // const [isTabsDraggingOpened, setIsTabsDraggingOpened] = useState(false)
    const [selectedIconName, setSelectedIconName] = useState<"Select" | "Layout" | "" | "Drag">("");
    const { activeGroup, activeTicker, error } =
        useAppSelector((state) => state.settings);
    const tabsListWrapper = useRef<HTMLDivElement>(null);
    const settingsWrapper = useRef<HTMLDivElement>(null);
    // const dragWrapper = useRef<HTMLDivElement>(null)

    const tabRef = useRef<HTMLDivElement>(null);
    const tabSettingsRef = useRef<HTMLDivElement>(null);
    // const dragRef = useRef<HTMLDivElement>(null)

    const unblockTickerOnLeave = (body: any) => {
        fetch(`${server_pathname}api/unblock`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${Cookies.get('access')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
    }

    const handleLogOutClick = async () => {
        if (activeTicker.name.length) {
            unblockTickerOnLeave({
                blockIt: false,
                group_name: activeGroup.name,
                ticker_name: activeTicker.name
            });
        }

        Cookies.remove("access")
        Cookies.remove("activePageId")

        dispatch(logOut());
        dispatch(resetTabsState());
        dispatch(resetQuotesPageState());
        dispatch(resetQuotesState());

        const timeout = setTimeout(() => {
            dispatch(resetState());
            clearTimeout(timeout);    
        }, 50);
    };

    const handleTabsSelectIconClick = (type: "close" | "open") => () => {
        if (type === "open") {
            setIsTabsSelectOpened(true);
            setSelectedIconName("Select");
        } else if (type === "close") {
            setIsTabsSelectOpened(false);
            setSelectedIconName("");
        }
    };

    const handleTabsLayoutIconClick = (type: "open" | "close") => () => {
        if (type === "open") {
            setIsTabsLayoutOpened(true);
            setSelectedIconName("Layout");
        } else if (type === "close") {
            setIsTabsLayoutOpened(false);
            setSelectedIconName("");
        }
    };
    // const handleDragIconClick = (type: "open" | "close") => () => {
    //     if (type === "open") {
    //         setIsTabsDraggingOpened(true)
    //         setSelectedIconName("Drag")
    //     } else if (type === "close") {
    //         setIsTabsDraggingOpened(false)
    //         setSelectedIconName("")
    //     }
    // }

    // const handleDragIconClick = () => {
    //     setIsTabsDraggingOpened(!isTabsDraggingOpened)
    // }

    return (
        <>
            <RightWrapper>
                <RightIcons>
                    <IconWrapper>
                        <Icon onClick={handleLogOutClick}>
                            <CustomLogOut/>
                        </Icon>
                    </IconWrapper>
                    {pathname === "/quotes" && (
                        <>
                            <IconWrapper ref={tabsListWrapper}>
                                <Icon
                                    ref={tabRef}
                                    onClick={
                                        !isTabsSelectOpened
                                            ? handleTabsSelectIconClick("open")
                                            : handleTabsSelectIconClick("close")
                                    }
                                    className={
                                        selectedIconName === "Select"
                                            ? "selected"
                                            : ""
                                    }
                                >
                                    <CustomTabsIcon/>
                                </Icon>
                                {isTabsSelectOpened && (
                                    <TabsSideDropdown
                                        isOpen={isTabsSelectOpened}
                                        ref={tabRef}
                                        wrapperRef={tabsListWrapper}
                                        closeHandler={handleTabsSelectIconClick(
                                            "close"
                                        )}
                                    />
                                )}
                            </IconWrapper>
                            <IconWrapper ref={settingsWrapper}>
                                <Icon
                                    ref={tabSettingsRef}
                                    onClick={
                                        !isTabsLayoutOpened
                                            ? handleTabsLayoutIconClick("open")
                                            : handleTabsLayoutIconClick("close")
                                    }
                                    className={
                                        selectedIconName === "Layout"
                                            ? "selected"
                                            : ""
                                    }
                                >
                                    <CustomTabsSettingsIcon/>
                                </Icon>
                                {isTabsLayoutOpened && (
                                    <TabsLayoutDropdown
                                        isOpen={isTabsLayoutOpened}
                                        ref={tabSettingsRef}
                                        wrapperRef={settingsWrapper}
                                        closeHandler={handleTabsLayoutIconClick(
                                            "close"
                                        )}
                                    />
                                )}
                            </IconWrapper>
                            {/*<IconWrapper ref={dragWrapper}>*/}
                            {/*    <Icon*/}
                            {/*        onClick={!isTabsDraggingOpened ? handleDragIconClick("open") : handleDragIconClick("close")}*/}
                            {/*        ref={dragRef}*/}
                            {/*        className={selectedIconName === "Drag" ? "selected" : ""}*/}
                            {/*    >*/}
                            {/*        <b>?</b>*/}
                            {/*    </Icon>*/}
                            {/*    {isTabsDraggingOpened &&*/}
                            {/*        <TabsDragDropdown*/}
                            {/*            isOpen={isTabsDraggingOpened}*/}
                            {/*            ref={dragRef}*/}
                            {/*            wrapperRef={dragWrapper}*/}
                            {/*            closeHandler={handleDragIconClick("close")}*/}
                            {/*        />*/}
                            {/*    }*/}
                            {/*</IconWrapper>*/}
                        </>
                    )}
                    {pathname === "/settings" && <Settings/>}
                </RightIcons>
            </RightWrapper>
        </>
    );
};

export default RightSideMenu;
